module.exports = __webpack_public_path__ + "images/rhone-2.ddb73c3034aadc950c75fb0459e51127.svg";